export { default as sendAutomatedMessage } from './actions/sendAutomatedMessage';
